var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNonAlarm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.673964 10.7586L0.666016 10.7666L0.673964 10.7745V10.7856H0.685092L3.91219 14.0127L4.95333 15.0539V15.0658H4.96526L4.97286 15.0734L4.98045 15.0658H6.45333H9.54413H11.0179L11.0258 15.0738L11.0338 15.0658H11.0441V15.0555L12.0865 14.0131L15.314 10.7856H15.3243V10.7753L15.3327 10.7669L15.3243 10.7585V9.28565V6.19486V4.72197L15.3322 4.71407L15.3243 4.70616V4.69486H15.313L11.0441 0.42599V0.415487L11.0336 0.415487L11.0254 0.407227L11.0171 0.415487L9.54412 0.415487L7.98732 0.415487L6.45333 0.415487L4.98125 0.415487L4.97334 0.407577L4.96543 0.415487L4.95333 0.415487V0.427582L3.91268 1.46824L0.686058 4.69486H0.673964V4.70695L0.666499 4.71442L0.673964 4.72188V6.19486V9.28565V10.7586ZM7.99805 10.7412C9.6549 10.7412 10.998 9.39807 10.998 7.74121C10.998 6.08436 9.6549 4.74121 7.99805 4.74121C6.34119 4.74121 4.99805 6.08436 4.99805 7.74121C4.99805 9.39807 6.34119 10.7412 7.99805 10.7412Z",
    fill: "#00375E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonAlarm);
export default __webpack_public_path__ + "static/media/NonAlarm.2ca4fe84e07802602d3f51a589a5cb8c.svg";
export { ForwardRef as ReactComponent };